import { Company, Project } from "../types";

export const ENTIK_RECORDS_COMPANY_ID =
  process.env.REACT_APP_ENTIK_RECORDS_COMPANY_ID ||
  "237065b3-79ff-11f0-9c27-0200170a6044";

export const ENTIK_RECORDS_PROJECT_SLUG = "entik-records";

const DANIEL_CIF = "50635458S";

/**
 * Allowlist estricta (propietario Entik Records):
 * saikoner@gmail.com, info@entikmedia.com — más empresa CIF 50635458S.
 */
export const ENTIK_RECORDS_ALLOWED_EMAILS = [
  "saikoner@gmail.com",
  "info@entikmedia.com",
];

export function isEntikRecordsAllowlistedEmail(email?: string | null): boolean {
  const normalized = String(email || "").trim().toLowerCase();
  return ENTIK_RECORDS_ALLOWED_EMAILS.includes(normalized);
}

/** Empresa Daniel Vázquez Moreno (50635458S) — única con integración Entik Records. */
export function isDanielEntikCompany(company: Company | null | undefined): boolean {
  if (!company) return false;
  if (company.id === ENTIK_RECORDS_COMPANY_ID) return true;
  const cif = (company.cif || "").replace(/\s/g, "").toUpperCase();
  return cif === DANIEL_CIF;
}

/** @deprecated Usar isDanielEntikCompany */
export function isEntikRecordsCompany(company: Company | null | undefined): boolean {
  return isDanielEntikCompany(company);
}

export function isEntikRecordsProject(
  project: Pick<Project, "id" | "slug"> | null | undefined,
  projects?: Pick<Project, "id" | "slug">[]
): boolean {
  if (!project) return false;
  if (project.slug === ENTIK_RECORDS_PROJECT_SLUG) return true;
  const match = projects?.find((p) => p.id === project.id);
  return match?.slug === ENTIK_RECORDS_PROJECT_SLUG;
}

/**
 * Acceso Entik: admin/superadmin en empresa Daniel + email allowlist.
 * Rol `usuario` (colaboradores plataforma) nunca accede, aunque comparta empresa.
 */
export function canAccessEntikRecords(
  company: Company | null | undefined,
  userEmail?: string | null,
  userRole?: string | null
): boolean {
  const role = String(userRole || "").toLowerCase();
  if (role === "usuario") return false;
  if (!isEntikRecordsAllowlistedEmail(userEmail)) return false;
  return isDanielEntikCompany(company);
}

/**
 * Pestaña Entik Records: propietario allowlist + proyecto Entik Records (si hay filtro).
 */
export function shouldShowEntikRecordsTab(
  company: Company | null | undefined,
  currentProjectId: string | null,
  projects: Pick<Project, "id" | "slug">[],
  userEmail?: string | null,
  userRole?: string | null
): boolean {
  if (!canAccessEntikRecords(company, userEmail, userRole)) return false;
  if (!currentProjectId) return true;
  const current = projects.find((p) => p.id === currentProjectId);
  return current?.slug === ENTIK_RECORDS_PROJECT_SLUG;
}
